/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { WPData } from '../Serialization/WBPD/w-p-data';

import * as THREE from 'three';
import * as flatbuffers from 'flatbuffers';
import * as DT from '@/engine/PlanningAlgorithm/DataTypes';
import { importNamesMapping, type IImporter, type ImportResult, type ImporterConfig } from './IImporter';

export class WBPDImporter implements IImporter {
  private readonly _blobProvider: () => Promise<ArrayBuffer>;

  public constructor(blobProvider: () => Promise<ArrayBuffer>) {
    this._blobProvider = blobProvider;
  }

  public async import(result: ImportResult, config: ImporterConfig): Promise<void> {
    const buffer = await this._blobProvider();
    const data = new Uint8Array(buffer);
    const buf = new flatbuffers.ByteBuffer(data);
    const header = WPData.getRootAsWPData(buf);

    // PolylinesVectors
    const polylinesVectors = importNamesMapping(config.polylinesVectors);
    for (let i = 0, sz = header.polylineTreesLength(); i < sz; ++i) {
      const tree = header.polylineTrees(i)!;
      const guid = tree.guid()!;
      const label = tree.label()!.toLowerCase();
      const values = polylinesVectors.get(label) || [];
      for (const value of values) {
        const imageId = tree.imageGuid()!;
        const data = result.phaseData.get(imageId);
        if (data) {
          const polylinesVector: Array<DT.Polyline> = [];

          for (let j = 0; j < tree.polylinesLength(); ++j) {
            const polyline = tree.polylines(j)!;
            const basePoints: Array<THREE.Vector3> = [];

            for (let k = 0; k < polyline.pointsLength(); ++k) {
              const point = polyline.points(k)!;
              basePoints.push(new THREE.Vector3(point.x(), point.y(), point.z()));
            }
            polylinesVector.push(new DT.Polyline({ points: basePoints, isClosed: false }));
          }

          if (data.valuesCollection.has(value.algoName)) {
            const duplicates = result.imageIdToDuplicateEntities.get(imageId);
            if (!duplicates) {
              result.imageIdToDuplicateEntities.set(imageId, [[label, guid]]);
            } else {
              duplicates.push([label, guid]);
            }
          }

          data.valuesCollection.set(value.algoName, new DT.PolylinesVector({ polylines: polylinesVector }));
        }
      }
    }
  }
}
